import styled from 'styled-components'

export const StyledMyPageBasketsSharedToYou = styled.div`
  padding: 0 15px;
`
